import { useTheme } from '@mui/material';

export const IntroIcon2 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="29"
            viewBox="0 0 24 29"
            fill="none"
        >
            <path
                d="M12 3.15724C14.3679 3.15724 16.2857 5.0751 16.2857 7.44296V10.8715H7.71429V7.44296C7.71429 5.0751 9.63214 3.15724 12 3.15724ZM5.14286 7.44296V10.8715H3.42857C1.5375 10.8715 0 12.409 0 14.3001V24.5858C0 26.4769 1.5375 28.0144 3.42857 28.0144H20.5714C22.4625 28.0144 24 26.4769 24 24.5858V14.3001C24 12.409 22.4625 10.8715 20.5714 10.8715H18.8571V7.44296C18.8571 3.65546 15.7875 0.585815 12 0.585815C8.2125 0.585815 5.14286 3.65546 5.14286 7.44296ZM3.42857 13.443H20.5714C21.0429 13.443 21.4286 13.8287 21.4286 14.3001V24.5858C21.4286 25.0572 21.0429 25.443 20.5714 25.443H3.42857C2.95714 25.443 2.57143 25.0572 2.57143 24.5858V14.3001C2.57143 13.8287 2.95714 13.443 3.42857 13.443ZM13.2857 17.7287C13.2857 17.0162 12.7125 16.443 12 16.443C11.2875 16.443 10.7143 17.0162 10.7143 17.7287V21.1572C10.7143 21.8697 11.2875 22.443 12 22.443C12.7125 22.443 13.2857 21.8697 13.2857 21.1572V17.7287Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
